import CloseModal from "./CloseModal";
import classNames from "classnames";

export default function MyModal({
  closeModal,
  showModal,
  children,
  slideModal,
  closeIcon,
  closeAbsolute,
  customWidth,
  withOutClose = false,
}: any) {
  return showModal ? (
    slideModal ? (
      <div className="fixed inset-0 z-50 overflow-y-auto ">
        <div
          className="fixed inset-0 w-full h-full bg-black/40 "
          onClick={() => {
            if (!withOutClose) closeModal();
            else return;
          }}
        />

        <div className="flex justify-end min-h-screen py-4 pr-2 ">
          <div
            className={classNames(
              "relative w-full  h-slide-modal  bg-white rounded-2xl shadow-lg overflow-auto ml-2 md:ml-0",
              customWidth ? customWidth : "max-w-2xl",
            )}
          >
            {closeIcon && <CloseModal toggle={closeModal} />}
            {children}
          </div>
        </div>
      </div>
    ) : (
      <div className="fixed inset-0 z-50 overflow-y-auto ">
        <div
          className="fixed inset-0 w-full h-full bg-opacity-modal "
          onClick={() => {
            if (!withOutClose) closeModal();
            else return;
          }}
        />

        <div className="flex items-center min-h-screen px-4 py-8">
          <div className="relative w-full max-w-xs md:max-w-2xl sm:max-w-xs p-4 mx-auto bg-white rounded-3xl shadow-lg">
            {closeIcon && (
              <CloseModal toggle={closeModal} absolute={closeAbsolute} />
            )}

            {children}
          </div>
        </div>
      </div>
    )
  ) : null;
}
